import { Status } from '@finpay-development/shared-components';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { formatNumberToUSD } from '../../../shared/calculators';
import { StatusColors } from '../../../shared/enums';
import { RootState } from '../../../shared/state/root-reducer';
import { Vob, PayorPlan } from '@finpay-estimation/estimation-types';

export function EstDetails() {
  const patient = useSelector(
    (state: RootState) => state.patientContext.selectedPatient
  );

  const vobState = useSelector(
    (state: RootState) => state.vobContext.selectedVob as any as Vob
  );

  const rateAsPayorPlan = useSelector(
    (state: RootState) => state.estimatorContext.rateAsPayorPlan
  ) as PayorPlan | null;

  const estimate = useSelector(
    (state: RootState) =>
      state?.estimatorContext.selectedEstimate
  );

  const lengthOfStay = estimate?.summary?.lengthOfStayCovered ?? 0;

  const totalEstimatedPFR = estimate?.summary?.totalPFR ?? 0;

  return (
    <>
        <Grid container spacing={2}>

          <Grid item direction="column" md={4} sm={4}>
            <strong>
              {patient?.contact?.firstName}
              {patient?.contact?.lastName}
            </strong>
            /{patient?.patientId}
            <Typography variant="body2">
              {rateAsPayorPlan?.payor?.payorName}/{rateAsPayorPlan?.plan?.planName} 
            </Typography>
          </Grid>
          <Grid item direction="column" md={4} sm={4} >
            {vobState.client.clientName}
            <Typography variant="body2">{vobState.facility.facilityName}</Typography>
          </Grid>
          <Grid item direction="column" md={4} sm={4}>
            <strong>{formatNumberToUSD(totalEstimatedPFR)}</strong>
            <Typography variant="body2">EST. PFR</Typography>
          </Grid>
        </Grid>
				<Grid container spacing={2} style={{marginTop: '1px'}}>
				  <Grid item direction="column" md={4} sm={4}>
            {vobState?.payor?.payorName !== "Self-Pay" && (
              <Status
                text={vobState?.activePolicy ? "Active Policy" : "Inactive Policy"}
                statusColor={
                  vobState?.activePolicy ? StatusColors.success : StatusColors.error
                }
              />
            )}
          </Grid>
					<Grid item direction="column" md={4} sm={4}>
            {vobState?.payor?.payorName !== "Self-Pay" && (
              <Status
                text={rateAsPayorPlan?.payor?.inNetwork ? "In Network" : "Out of Network"}
                statusColor={
                  rateAsPayorPlan?.payor?.inNetwork ? StatusColors.success : StatusColors.error
                }
              />
            )}
					</Grid>
					<Grid item direction="column" md={4} sm={4}>
					<Typography variant="body2">LOS {lengthOfStay} days</Typography>
					</Grid>
				</Grid>

</>
  );
}
